import { apiFetch } from "./client";

export const searchProducts = (query) =>
  apiFetch(`/enduser/product/?search=${encodeURIComponent(query)}`);
export const fetchProducts = () =>
  apiFetch("/enduser/products/", {
    credentials: "include",
  });
  export const fetchexclusive = () =>
  apiFetch("/enduser/products/exclusive/", {
    credentials: "include",
  });


export const fetchProductById = (id) =>
  apiFetch(`/enduser/products-detail/${id}/`, {
    credentials: "include",
  });

  export const fetchRelatedProducts = (id) =>
  apiFetch(`/enduser/products-related/${id}/`, {
    credentials: "include",
  });